import { MarketAccessory, MarketList, MarketRow } from '@market/react';
import { Icon, type IconName } from '@squareup/shared-ui-react';
import styles from './ValuePropositions.module.css';

export interface ValuePropositionsProps {
  readonly valueProps: ValueProposition[];
  readonly title?: string;
}

export interface ValueProposition {
  readonly label: string;
  readonly icon: IconName;
}

export const ValuePropositions = ({ valueProps, title }: ValuePropositionsProps) => (
  <section className={styles.valuePropsContainer} data-testid="value-propositions">
    {title && <h2 className={`heading-30 ${styles.valuePropsTitle}`}>{title}</h2>}
    <MarketList className={styles.valueProps}>
      {valueProps.map((valueProp) => (
        <MarketRow key={valueProp.icon}>
          <label slot="label">{valueProp.label}</label>
          <MarketAccessory
            className={styles.valuePropIcon}
            size="image"
            slot="leading-accessory"
          >
            <Icon iconName={valueProp.icon} size="medium" />
          </MarketAccessory>
        </MarketRow>
      ))}
    </MarketList>
  </section>
);
